var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.9999 36.6663c9.2048 0 16.6667-7.4619 16.6667-16.6666 0-9.2048-7.4619-16.66669-16.6667-16.66669-9.2047 0-16.66665 7.46189-16.66665 16.66669 0 9.2047 7.46195 16.6666 16.66665 16.6666z",
    fillOpacity: 0.35,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.3332 14.492c0-1.0283-1.24-1.545-1.97-.8216l-5.19 5.1416c-.66.655-.66 1.7217 0 2.3767l5.19 5.1417c.73.7233 1.97.205 1.97-.8217z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.6667 21.6663h11.6667c.92 0 1.6667-.7466 1.6667-1.6666s-.7467-1.6667-1.6667-1.6667c-.58 0-11.6667 0-11.6667 0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.e04c3ff77d8ef9943530c2f054b18236.svg";
export { ForwardRef as ReactComponent };